import clsx from 'clsx'
import '../../components/loaders/infiniteLoader.css'

type Props = {
  variant?: string,
  className?: string
}

const InfiniteLoader: React.FC<Props> = ({className = ""}) => {
  return (
    <div className={clsx("horizontal-loader-container", className)}>
      <div className={`horizontal-loader`}></div>
    </div>
  );
}

export default InfiniteLoader